<style lang="less">
.flex-table{
  .ivu-row{
    padding:0;
  }
  .ivu-col{
    border-right:1px solid var(--border);
    flex-shrink: 1;
    flex-grow:0;
    overflow:hidden;
  }
  .ivu-col:last-child{
    border-right:none;
  }

  .caption-line{
    background:var(--bg2);
  }

  .ivu-form-item-content{
    padding:0 !important;

    .ivu-input-wrapper{
      width:100% !important;
      input{
        width:100% !important;
      }
    }
  }
  

}
</style>
<template>
  <div class="container flex-table">
      <Row
        :gutter="10"
        class-name="l-bill caption-line"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="c.span || computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;font-weight:bold" v-if="!c.if || model[c.if]" :key="c.key">{{c.name || ""}}</Col>
        </template>
        <Col :span="4" align="center"  v-if="!hideTool">操作</Col>
      </Row>

      <Row
        :gutter="10"
        class-name="l-bill"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="c.span || computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;color:var(--success)" :key="c.key">{{c.width || ""}}</Col>
        </template>
        <Col :span="4" align="center"  v-if="!hideTool">25%</Col>
      </Row>

      <Row
        :gutter="10"
        class-name="l-bill"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="c.span || computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;color:var(--subtext2)"  :key="c.key">{{computedColumnWidthds[index] || ""}}</Col>
        </template>
        <Col :span="4" align="center"  v-if="!hideTool">25%</Col>
      </Row>
      <Row
        :gutter="10"
        class-name="l-bill"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
            <Col :flex="c.span || computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;color:var(--subtext2)"  :key="c.key">{{ mapControlName(c.control) }}</Col>
        </template>
        <Col :span="4" align="center"  v-if="!hideTool">25%</Col>
      </Row>
      
      <!-- <Row
        :gutter="10"
        class-name="l-bill"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="c.span || computedColumnWidthds[index]" 

           :class="{'width-auto':c.width == 'auto'}"
                      style="display:flex;overflow:hidden;text-align:center;align-items:center;"  :key="c.key">
              <div v-if="c.control=='drag'" class="draggable" style="cursor:grab">
                <BaseIcon icon="md-menu" />
              </div>
              <span v-else-if="c.control=='index'"  :key="'_colc'+c.key+index">{{index+1}}</span>
              <component v-else :is="c.control" size="small" :editable="true" :config="c.config"  />
              {{ c.item }}
           </Col>
        </template>
        <Col :span="4" align="center"  v-if="!hideTool">25%</Col>
      </Row> -->



      <Draggable
        v-model="items"
        :animation="500"
        handle=".draggable"
        @input="emitChange"
      >
        <template v-for="(item,index) in items">
          <Row :key="item.id" :gutter="10" class-name="l-bill">
            <template v-for="c in columns">
              
            <Col :flex="c.span || computedColumnWidthds[index]" 
            :class="{'width-auto':c.width == 'auto'}"
            :key="c.key" v-if="!c.if || model[c.if]" style="text-align:center">
           
              <div v-if="c.control=='drag'" class="draggable" style="cursor:grab">
                <BaseIcon icon="md-menu" />
              </div>
              <span v-else-if="c.control=='index'"  :key="'_colc'+c.key+index">{{index+1}}</span>
              <component v-else :is="c.control" size="small" :editable="true" :config="c.config"  @click="handleClick(c,item,index)" @input="emitChange" v-model="item[c.key]" />
              
            </Col>
            </template>
             <Col :span="4" v-if="!hideTool">
                 <div class="flex-wrap split5"><Button size="small" style="flex-shrink:0" @click="copy(index)" icon="md-copy"></Button><Button  style="flex-shrink:0" size="small" @click="remove(index)" icon="md-remove"></Button></div>
             </Col>
          </Row>
        </template>
      </Draggable>

      <BaseEmpty v-if="items.length == 0" image style="padding:20px;">
        <div class="flex-wrap flex-center" style="margin-bottom:20px" >
         <Button icon="md-add" size="small" @click="add">新增一行</Button>
          <slot name="button"></slot>
        </div>
      </BaseEmpty>
      <div v-else class="flex-wrap flex-between" style="margin:5px 10px">
        <Alert v-if="error" type="error" size="small" style="padding:3px 5px">{{error}}</Alert>
        <div class="flex-wrap"  style="margin-bottom:20px;margin-top:5px;">

          <Button icon="md-add" size="small" @click="add">新增一行</Button>
          <slot name="button"></slot>
        </div>
      </div>
      <Row :gutter="10" class-name="l-bill" v-if="summary && items.length > 0">
        <template v-for="(c,i) in columns">
        <Col :flex="c.span || computedColumnWidthds[index]"
        :class="{'width-auto':c.width == 'auto'}"
         :key="'_col_sum'+(c.key || i)" style="text-align:center">

          <span v-if="c.summarable"  :key="'_col_sum'+c.key">{{index+1}}</span>
        </Col>
        </template>
      </Row>
  </div>
</template>
<script>

import Draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
function evil(fn, params) {
  params.fix = (total, items, key, index)=>{
    return formatNumber(total - formatNumber(items.filter((v, i)=>i!=index).reduce((acc, item)=>{
      return acc + item[key];
    }, 0)));
  };
  const Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
  return new Fn('params', 'console.log(params);console.log('+fn+');return ' + fn)(params);
}
function formatNumber(e) {
  if (isNaN(e)) {
    return 0;
  } else {
    return parseInt(e*100)/100;
  }
}
export default {
  components: {Draggable},
  data() {
    return {
      items: [],
      vid: 0,
      computedColumnWidthds:[]
    };
  },
  created() {
    this.vid = parseInt(Math.random()*10000);
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    design: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: ()=>([]),
    },
    error: {
      type: String,
      default: ()=>'',
    },
    summary: {
      type: Boolean,
    },
    model: {
      type: Object,
      default: ()=>({}),
    },
    ordered: {
      type: Boolean,
      default: true,
    },
    hideTool:{
      type: Boolean,
      default: false,
    }
  },
  watch: {
    value: {
      handler(v) {
        if (Array.isArray(this.value)) {
          this.items = cloneDeep(this.value);
          
        } else {
          this.items = [];
          this.emitChange();
        }
        this.ComputeColumnWidths()
      },
      immediately: true,
      deep: true,
    },
  },
  mounted() {
    this.$bus.$on('calc-flex-table',()=>{
      this.ComputeColumnWidths()
    })
    if (Array.isArray(this.value)) {
      this.items = cloneDeep(this.value);
    } else {
      this.items = [];
      this.vid = parseInt(Math.random()*1000);
      this.emitChange();
    }

    this.$nextTick(()=>{
      this.ComputeColumnWidths()
    })
  },
  beforeDestroy() {
    this.$bus.$off('calc-flex-table')
  },
  methods: {
    ComputeColumnWidths(){
      console.log('computed')
      let autoWidth = 0
      let auto_count = 0
      let valuedWith = this.columns.reduce((acc, v)=>{
        let width = this.computeWidth(v.width)
        if(width !== 'auto')
          return acc + ( parseInt(width) || 0)
        else
          auto_count++
        return acc
      }, 0);
      let total_width = this.$el ? this.$el.offsetWidth : 0
      if(auto_count > 0)
        autoWidth = parseInt(10*(total_width - valuedWith) / auto_count)/10
      else 
        autoWidth = 0

      this.computedColumnWidthds = this.columns.map((v)=>{
        let width = this.computeWidth(v.width)
        if(width !== 'auto')
          return width
        else{
          return autoWidth + 'px'
        }
      });
    },
    mapControlName(control){
      switch(control){
        case 'UgoInput':
          return '单行文本';
        case 'UgoNumber':
          return '数值';
        case 'UgoTextarea':
          return '多行文本';
        case 'UgoDate':
          return '日期';
        case 'UgoRadio':
          return '单选';
        case 'UgoInputSelect':
          return '输入选择框';
        case 'UgoFileUpload':
          return '文件';
        case 'UgoImage':
          return '图片';
        case 'UgoMultiSelect':
          return '多选';
        default:
          return control;
      }
    },
    computeWidth(width) {
      // 获取容器的宽度
      let total = this.$el ? this.$el.offsetWidth : 100;
      if(!width || width == 'auto') return 'auto';
    if (typeof width === 'string' && width.endsWith('%')) {
      // Convert percentage to 12 span grid (e.g. 50% => 6)
      const percent = parseFloat(width);
      if (!isNaN(percent)) {
        return `${Math.round(total * percent / 100)}px`;
      }
      return 'auto';
    }
    if (typeof width === 'number') {
      return width + 'px';
    }
    if (typeof width === 'string' && /^\d+$/.test(width)) {
      return width + 'px';
    }
    // fallback
    return width;
    },
    handleClick(c, item, index) {
      const model = this.model;
      if (c.control=='Button') {
        this.$set(item, c.to, formatNumber(evil(c.from, {model, item, index})));
      }
    },
    validate() {
      if (this.check_result.state == 'success') {
        return true;
      }
    },
    getError() {
      return this.check_result.message;
    },
    emitChange() {
      if (this.ordered) {
        this.items.forEach((v, i)=>v.order=(i+1));
      } else {
        this.items.forEach((v, i)=>delete v.order);
      }
      this.$emit('input', this.items);
    },
    add() {
      this.items.push({});
    },
    copy(i) {
      this.items.splice(i, 0, {...this.items[i], id: undefined});
      this.$emit('input', this.items);
    },
    remove(i) {
      this.items.splice(i, 1);
      this.$emit('input', this.items);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
